<template>
  <section>
    <div class="page-head">
      <div>
        <h1 class="page-title">Grupos</h1>
        <p class="page-sub">Administrar grupos: crear, editar, eliminar y asignar permisos</p>
      </div>
      <div class="page-actions">
        <button class="button is-primary" @click="openForm"><b-icon icon="plus" pack="mdi" size="is-small"></b-icon>&nbsp;Agregar Grupo</button>
      </div>
    </div>

    <div class="box table-card">
      <table class="table is-fullwidth is-striped">
        <thead>
          <tr>
            <th>Nombre de grupo</th>
            <th>Nombre jefe de grupo</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="g in grupos" :key="g.id">
            <td>{{ g.nombre }}</td>
            <td>
              <span v-if="!g.jefe || g.jefe === ''" class="asignar-jefe">Asignar jefe</span>
              <span v-else>{{ g.jefe }}</span>
            </td>
            <td>
              <button class="button is-small is-info is-light" @click="editGrupo(g)"><b-icon icon="pencil" pack="mdi" size="is-small"></b-icon>&nbsp;Editar</button>
              <button class="button is-small is-danger is-light" @click="eliminarGrupo(g)"><b-icon icon="trash-can" pack="mdi" size="is-small"></b-icon>&nbsp;Eliminar</button>
              <button class="button is-small is-light" @click="permisosGrupo(g)"><b-icon icon="shield-check" pack="mdi" size="is-small"></b-icon>&nbsp;Permisos</button>
            </td>
          </tr>
          <tr v-if="grupos.length === 0">
            <td colspan="3" class="has-text-centered">No hay grupos aún.</td>
          </tr>
        </tbody>
      </table>

      <!-- Modal de formulario simple -->
      <div class="modal" :class="{'is-active': showForm}">
        <div class="modal-background" @click="closeForm"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ editing ? 'Editar Grupo' : 'Nuevo Grupo' }}</p>
            <button class="delete" aria-label="close" @click="closeForm"></button>
          </header>
          <section class="modal-card-body">
            <div class="field">
              <label class="label">Nombre de grupo</label>
              <div class="control">
                <input class="input" v-model="form.nombre" placeholder="Ej. Grupo A">
              </div>
            </div>

            <!-- Número celular eliminado según solicitud -->
          </section>
          <footer class="modal-card-foot">
            <button class="button is-success" @click="guardarGrupo">{{ editing ? 'Guardar' : 'Crear' }}</button>
            <button class="button" @click="closeForm">Cancelar</button>
          </footer>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import HttpService from '@/Servicios/HttpService'

export default {
  name: 'GruposComponent',
  data() {
    return {
      grupos: [],
      showForm: false,
      editing: false,
      form: {
        id: null,
        nombre: ''
      }
    }
  },
  created() {
    this.loadGrupos()
  },
  methods: {
    async loadGrupos() {
      try {
        const data = await HttpService.obtenerConConsultas('grupos.php', { accion: 'obtener' })
        this.grupos = Array.isArray(data) ? data : []
      } catch (e) {
        this.grupos = []
      }
    },
    openForm() {
      this.editing = false
      this.form = { id: null, nombre: '' }
      this.showForm = true
    },
    closeForm() {
      this.showForm = false
    },
    editGrupo(g) {
      this.editing = true
      this.form = Object.assign({}, g)
      this.showForm = true
    },
    async guardarGrupo() {
      if (!this.form.nombre) { alert('El nombre es requerido'); return }
      let data;
      try {
        if (this.editing) {
          data = await HttpService.obtenerConConsultas('grupos.php', { accion: 'editar', grupo: this.form })
        } else {
          data = await HttpService.obtenerConConsultas('grupos.php', { accion: 'registrar', grupo: this.form })
        }
        if (data && data.error) {
          alert('Error del backend: ' + data.error)
          return;
        }
      } catch (e) {
        alert('Error de conexión con el backend: ' + e.message)
        return;
      }
      await this.loadGrupos()
      this.closeForm()
    },
    async eliminarGrupo(g) {
      if (!confirm('¿Eliminar grupo "' + g.nombre + '"?')) return
      await HttpService.obtenerConConsultas('grupos.php', { accion: 'eliminar', id: g.id })
      await this.loadGrupos()
    },
    permisosGrupo(g) {
      alert('Abrir permisos para: ' + g.nombre + ' (pendiente de implementar)')
    }
  }
}
</script>

<style scoped>
.box{ padding:1rem }
.modal-card{ width: 640px }
.asignar-jefe {
  color: #e57373;
  background: #fff7f7;
  border-radius: 10px;
  padding: 0.05em 0.45em;
  font-weight: 400;
  border: 1px solid #ffe0e0;
  display: inline-block;
  font-size: 0.82em;
  box-shadow: none;
  letter-spacing: 0.2px;
  transition: background 0.2s, color 0.2s;
}
.asignar-jefe:hover {
  background: #ffeaea;
  color: #d63031;
  cursor: pointer;
}
</style>
